  
import { RemoveModelAction } from './RemoveModelAction';
import { RemoveModelSuccessAction } from './RemoveModelSuccessAction';
import { UpdateModelAction } from './UpdateModelAction';
import { UpdateModelErrorAction } from './UpdateModelErrorAction';
import { UpdateModelSuccessAction } from './UpdateModelSuccessAction';

export type Actions<TParentModel,TModel> = RemoveModelAction<TParentModel,TModel> | RemoveModelSuccessAction<TParentModel,TModel> | UpdateModelAction<TParentModel,TModel> | UpdateModelErrorAction<TParentModel,TModel> | UpdateModelSuccessAction<TParentModel,TModel>;

export * from './RemoveModelAction';
export * from './RemoveModelSuccessAction';
export * from './UpdateModelAction';
export * from './UpdateModelErrorAction';
export * from './UpdateModelSuccessAction';
export * from './RefreshListAction';




// WEBPACK FOOTER //
// ./src/app/pillar/workspace/store/actions/index.ts